<template>
    <div class="text-center mt-9">
        <div>
            <i class="bi bi-x-circle-fill" style="font-size: 100px; color: #FFA500;"></i>
        </div>
        <div>
            <h3>Əməliyyat ləğv edildi</h3>
        </div>
        <div>
            <h6>Əlavə etmə əməliyyatı uğurla dayandırıldı.</h6>
            <h6>Dəyişikliklər yadda saxlanmadı.</h6>
        </div>
    </div>
</template>
<script>
import 'bootstrap-icons/font/bootstrap-icons.css';
export default {}
</script>